
import { useState, useEffect } from "react";
import { useToast } from "@/hooks/use-toast";
import { useInvoices } from "@/components/invoices/useInvoices";
import NewInvoiceForm from "@/components/invoices/NewInvoiceForm";
import InvoiceList from "@/components/invoices/InvoiceList";
import { useTranslation } from "@/i18n/useTranslation";

const Invoices = () => {
  const { toast } = useToast();
  const [showForm, setShowForm] = useState(false);
  const [activePeriod, setActivePeriod] = useState<string | null>(null);
  const { t, language } = useTranslation();

  const { 
    isLoading, 
    clients, 
    groupedInvoices, 
    defaultOpenValue,
    refetch 
  } = useInvoices();

  const toggleForm = (periodKey: string | null = null) => {
    if (periodKey) {
      setActivePeriod(periodKey);
      setShowForm(true);
    } else {
      setActivePeriod(null);
      setShowForm(false);
    }
  };

  const handleFormSuccess = () => {
    setShowForm(false);
    setActivePeriod(null);
    refetch();
  };

  if (isLoading) {
    return <div className="p-8">{t('invoices.loading')}</div>;
  }

  return (
    <div className="p-8 space-y-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">{t('invoices.title')}</h1>
      </div>

      {showForm && activePeriod && (
        <NewInvoiceForm
          activePeriod={activePeriod}
          groupedInvoices={groupedInvoices}
          clients={clients}
          onCancel={() => toggleForm()}
          onSuccess={handleFormSuccess}
          language={language}
        />
      )}

      {groupedInvoices.length > 0 ? (
        <InvoiceList
          groupedInvoices={groupedInvoices}
          clients={clients}
          defaultOpenValue={defaultOpenValue}
          onNewInvoice={toggleForm}
          language={language}
        />
      ) : (
        <div className="border rounded-lg p-8 text-center text-muted-foreground">
          {t('invoices.noInvoices')}
        </div>
      )}
    </div>
  );
};

export default Invoices;
